import Router from 'next/router'
import { type AxiosError } from 'axios'
import { proxySignIn, resetProxySignIn } from '../../../../proxySignIn'
import { buildAxiosInstance } from '../../../../../../../shared/utils/apiUtils'
import { proxyGlobalAuth } from '../../../../../../../shared/proxies/proxyGlobalAuth'
import { APP_PATH } from '../../../../../../../pages/app'
import { AFTER_LOGIN_PARAM_KEY } from '../../../../../../../shared/utils/authUtils'

interface Args {
  email: string
  password: string
  ppMerchantId: string
}

interface ResponseData {
  authToken: string
  passwordResetDate: string | null
}

interface Response {
  data: ResponseData | null
  error: string | null
}

export async function executeSignIn ({ email, password, ppMerchantId }: Args): Promise<void> {
  proxySignIn.apiCallSignIn.loading = true
  proxySignIn.apiCallSignIn.error = null
  try {
    const response = await buildAxiosInstance().post<Response>('/api/auth/sign_in', {
      email: email.toLowerCase(),
      password,
      ppMerchantId
    })
    if (response.data.data) {
      proxyGlobalAuth.authToken = response.data.data?.authToken
      const params = new URLSearchParams(window.location.search)
      const afterLoginPath = params.get(AFTER_LOGIN_PARAM_KEY)

      await Router.push(afterLoginPath || APP_PATH)
      resetProxySignIn()
    } else {
      proxySignIn.apiCallSignIn.error = 'Unknown Error'
    }
  } catch (e) {
    if (e instanceof Error) {
      const bodyError = (e as AxiosError<Response>).response?.data?.error
      proxySignIn.apiCallSignIn.error = bodyError ?? e.message
    }
  } finally {
    proxySignIn.apiCallSignIn.loading = false
  }
}
